<template>
  <UIDrawer
    :is-open
    :z-index
    direction="to-left"
    size="md"
    with-back
    flat
    class="main-mobile-header-user-panel"
    @close="handleClose"
  >
    <template #title>
      <UserCircleIcon
        aria-hidden="true"
        class="main-mobile-header-icon"
      />
      <div class="main-mobile-header-user-panel__email">
        {{ userEmail }}
      </div>
    </template>
    <User>
      <template #default="{ data }">
        <AppUserInfo :hide="handleClose" />
        <MainMobileHeaderUserLink
          v-for="(item, index) in data"
          :key="index"
          :item
          @close="handleClose"
        />
      </template>
    </User>
    <div class="main-mobile-header-user-version">{{ appVersion }}</div>
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { useUserStore } from '@/store/user'

import User from '../../components/User.vue'
import { UserCircleIcon } from '@heroicons/vue/24/outline'
import { AppUserInfo } from '@app'
import { UIDrawer } from '@ui/modals'
import MainMobileHeaderUserLink from './HeaderUserLink.vue'

type Props = {
  modal: ModalClass<any>
}

const props = defineProps<Props>()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const appVersion = `${__APP_VERSION__ || ''}`

const userStore = useUserStore()

const userEmail = computed(() => userStore.getEmail)

const handleClose = () => {
  props.modal.close()
}
</script>

<style>
.main-mobile-header-user-panel {
  .ui-drawer__title {
    @apply gap-2;
    @apply bg-primary;
    @apply overflow-hidden;
  }

  .main-mobile-header-icon {
    @apply shrink-0;
  }

  &__email {
    @apply font-normal;
    @apply text-sm sm:text-base;
    @apply truncate;
    @apply text-white;
  }

  .ui-button--gray-light {
    @apply !text-white;
    @apply hover:!bg-primary-dark focus:!bg-primary-dark;
    @apply !ring-0 !ring-offset-0;
  }
}

.main-mobile-header-user-version {
  @apply mt-auto mb-2;
  @apply text-xs;
  @apply text-light-text;
  @apply text-center;
}
</style>
